package com.xtream.data_kmp.db.dao

import androidx.room3.EntityDeleteOrUpdateAdapter
import androidx.room3.EntityInsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.coroutines.createFlow
import androidx.room3.util.getColumnIndexOrThrow
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import com.xtream.data_kmp.WatchedVodStreams
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.reflect.KClass
import kotlinx.coroutines.flow.Flow

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "MemberExtensionConflict"])
internal class WatchedVodDao_Impl(
  __db: RoomDatabase,
) : WatchedVodDao {
  private val __db: RoomDatabase

  private val __insertAdapterOfWatchedVodStreams: EntityInsertAdapter<WatchedVodStreams>

  private val __deleteAdapterOfWatchedVodStreams: EntityDeleteOrUpdateAdapter<WatchedVodStreams>
  init {
    this.__db = __db
    this.__insertAdapterOfWatchedVodStreams = object : EntityInsertAdapter<WatchedVodStreams>() {
      protected override fun createQuery(): String = "INSERT OR REPLACE INTO `watchedVodStreamsTable` (`streamId`,`progress`,`totalProgress`,`backdrop`,`added`) VALUES (?,?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: WatchedVodStreams) {
        statement.bindLong(1, entity.streamId.toLong())
        val _tmpProgress: Long? = entity.progress
        if (_tmpProgress == null) {
          statement.bindNull(2)
        } else {
          statement.bindLong(2, _tmpProgress)
        }
        val _tmpTotalProgress: Long? = entity.totalProgress
        if (_tmpTotalProgress == null) {
          statement.bindNull(3)
        } else {
          statement.bindLong(3, _tmpTotalProgress)
        }
        val _tmpBackdrop: String? = entity.backdrop
        if (_tmpBackdrop == null) {
          statement.bindNull(4)
        } else {
          statement.bindText(4, _tmpBackdrop)
        }
        statement.bindLong(5, entity.added)
      }
    }
    this.__deleteAdapterOfWatchedVodStreams = object : EntityDeleteOrUpdateAdapter<WatchedVodStreams>() {
      protected override fun createQuery(): String = "DELETE FROM `watchedVodStreamsTable` WHERE `streamId` = ?"

      protected override fun bind(statement: SQLiteStatement, entity: WatchedVodStreams) {
        statement.bindLong(1, entity.streamId.toLong())
      }
    }
  }

  public override suspend fun insertAll(vodStreams: List<WatchedVodStreams>): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfWatchedVodStreams.insert(_connection, vodStreams)
  }

  public override suspend fun insert(watchedStream: WatchedVodStreams): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfWatchedVodStreams.insert(_connection, watchedStream)
  }

  public override suspend fun delete(watched: WatchedVodStreams): Unit = performSuspending(__db, false, true) { _connection ->
    __deleteAdapterOfWatchedVodStreams.handle(_connection, watched)
  }

  public override suspend fun deleteAll(watchedList: List<WatchedVodStreams>): Unit = performSuspending(__db, false, true) { _connection ->
    __deleteAdapterOfWatchedVodStreams.handleMultiple(_connection, watchedList)
  }

  public override suspend fun getSingle(streamId: Int?): WatchedVodStreams? {
    val _sql: String = "SELECT * FROM watchedVodStreamsTable WHERE (streamId = ?) LIMIT 1"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (streamId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, streamId.toLong())
        }
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfProgress: Int = getColumnIndexOrThrow(_stmt, "progress")
        val _columnIndexOfTotalProgress: Int = getColumnIndexOrThrow(_stmt, "totalProgress")
        val _columnIndexOfBackdrop: Int = getColumnIndexOrThrow(_stmt, "backdrop")
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _result: WatchedVodStreams?
        if (_stmt.step()) {
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpProgress: Long?
          if (_stmt.isNull(_columnIndexOfProgress)) {
            _tmpProgress = null
          } else {
            _tmpProgress = _stmt.getLong(_columnIndexOfProgress)
          }
          val _tmpTotalProgress: Long?
          if (_stmt.isNull(_columnIndexOfTotalProgress)) {
            _tmpTotalProgress = null
          } else {
            _tmpTotalProgress = _stmt.getLong(_columnIndexOfTotalProgress)
          }
          val _tmpBackdrop: String?
          if (_stmt.isNull(_columnIndexOfBackdrop)) {
            _tmpBackdrop = null
          } else {
            _tmpBackdrop = _stmt.getText(_columnIndexOfBackdrop)
          }
          _result = WatchedVodStreams(_tmpStreamId,_tmpProgress,_tmpTotalProgress,_tmpBackdrop)
          _result.added = _stmt.getLong(_columnIndexOfAdded)
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getSingleFlow(streamId: Int?): Flow<WatchedVodStreams?> {
    val _sql: String = "SELECT * FROM watchedVodStreamsTable WHERE (streamId = ?) LIMIT 1"
    return createFlow(__db, false, arrayOf("watchedVodStreamsTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (streamId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, streamId.toLong())
        }
        val _columnIndexOfStreamId: Int = getColumnIndexOrThrow(_stmt, "streamId")
        val _columnIndexOfProgress: Int = getColumnIndexOrThrow(_stmt, "progress")
        val _columnIndexOfTotalProgress: Int = getColumnIndexOrThrow(_stmt, "totalProgress")
        val _columnIndexOfBackdrop: Int = getColumnIndexOrThrow(_stmt, "backdrop")
        val _columnIndexOfAdded: Int = getColumnIndexOrThrow(_stmt, "added")
        val _result: WatchedVodStreams?
        if (_stmt.step()) {
          val _tmpStreamId: Int
          _tmpStreamId = _stmt.getLong(_columnIndexOfStreamId).toInt()
          val _tmpProgress: Long?
          if (_stmt.isNull(_columnIndexOfProgress)) {
            _tmpProgress = null
          } else {
            _tmpProgress = _stmt.getLong(_columnIndexOfProgress)
          }
          val _tmpTotalProgress: Long?
          if (_stmt.isNull(_columnIndexOfTotalProgress)) {
            _tmpTotalProgress = null
          } else {
            _tmpTotalProgress = _stmt.getLong(_columnIndexOfTotalProgress)
          }
          val _tmpBackdrop: String?
          if (_stmt.isNull(_columnIndexOfBackdrop)) {
            _tmpBackdrop = null
          } else {
            _tmpBackdrop = _stmt.getText(_columnIndexOfBackdrop)
          }
          _result = WatchedVodStreams(_tmpStreamId,_tmpProgress,_tmpTotalProgress,_tmpBackdrop)
          _result.added = _stmt.getLong(_columnIndexOfAdded)
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getSize(): Long? {
    val _sql: String = "SELECT COUNT(*) FROM watchedVodStreamsTable"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: Long?
        if (_stmt.step()) {
          val _tmp: Long?
          if (_stmt.isNull(0)) {
            _tmp = null
          } else {
            _tmp = _stmt.getLong(0)
          }
          _result = _tmp
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun delete() {
    val _sql: String = "DELETE FROM watchedVodStreamsTable"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteById(streamId: Int?) {
    val _sql: String = "DELETE FROM watchedVodStreamsTable WHERE streamId = ?"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (streamId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, streamId.toLong())
        }
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteByOffset(offset: Int, limit: Int) {
    val _sql: String = """
        |
        |       DELETE FROM watchedVodStreamsTable
        |        WHERE streamId in 
        |(SELECT streamId FROM watchedVodStreamsTable ORDER BY added DESC  LIMIT ?  OFFSET ?)
        |   
        """.trimMargin()
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, limit.toLong())
        _argIndex = 2
        _stmt.bindLong(_argIndex, offset.toLong())
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
